import React, { useContext, useState, useEffect } from 'react'
import { growthbook } from '../services/growthbook'

export const ResponsiveContext = React.createContext({})
export const useResponsiveContext = () => useContext(ResponsiveContext)

const DESKTOP_BREAKPOINT = 768

export const ResponsiveContextProvider = ({ children }) => {
  const [isDesktop, setIsDesktop] = useState(false)

  useEffect(() => {
    // Set initial value
    const initialIsDesktop = window.innerWidth >= DESKTOP_BREAKPOINT
    setIsDesktop(initialIsDesktop)

    // Attribute the viewing device to GrowthBook (attribution only — does not
    // affect bucketing). updateAttributes MERGES, so it won't clobber id/market
    // attributes set in MarketContext/UserContext.
    growthbook.updateAttributes({ deviceType: initialIsDesktop ? 'desktop' : 'mobile' })

    const handleResize = () => {
      const newIsDesktop = window.innerWidth >= DESKTOP_BREAKPOINT
      // Only update when the breakpoint side actually flips
      if (newIsDesktop !== isDesktop) {
        setIsDesktop(newIsDesktop)
        growthbook.updateAttributes({ deviceType: newIsDesktop ? 'desktop' : 'mobile' })
      }
    }

    window.addEventListener('resize', handleResize, { passive: true })
    return () => window.removeEventListener('resize', handleResize)
  }, [isDesktop])

  return (
    <ResponsiveContext.Provider value={{ isDesktop }}>
      {children}
    </ResponsiveContext.Provider>
  )
}
